const envBaseURLs = {
    development: {
        attendance: "https://dev-attendance.minex360-staging.com",
        unifiedApi: "https://dev-unified-api.minex360-staging.com",
        authApi: "https://dev-auth.minex360-staging.com",
        canteenApi: "https://dev-canteen-v2.minex360-staging.com",
        notificationApi: "https://dev-notifications.minex360-staging.com",
        elearningApi: "https://dev-elearning.minex360-staging.com",
        paymentsApi: "https://dev-smartpay.minex360-staging.com",
        paroApi: "https://dev-paro.minex360-staging.com",
        sentryDSN: "https://87e0f2fe756d48a2b777225a52aa2342@sentry.smartsapp.com/22",
    },
    staging: {
        attendance: "https://attendance.minex360-staging.com",
        unifiedApi: "https://unified-api.minex360-staging.com",
        authApi: "https://auth.minex360-staging.com",
        canteenApi: "https://canteen-v2.minex360-staging.com",
        notificationApi: "https://notifications.minex360-staging.com",
        elearningApi: "https://elearning.minex360-staging.com",
        paymentsApi: "https://smartpay.minex360-staging.com",
        paroApi: "https://paro.minex360-staging.com",
        sentryDSN: "https://87e0f2fe756d48a2b777225a52aa2342@sentry.smartsapp.com/22",
    },
    production: {
        attendance: "https://attendance.minex360.com",
        unifiedApi: "https://unified-api.minex360.com",
        authApi: "https://auth.minex360.com",
        canteenApi: "https://canteen-v2.minex360.com",
        notificationApi: "https://notifications.minex360.com",
        elearningApi: "https://elearning.minex360.com",
        paymentsApi: "https://smartpay.minex360.com",
        paroApi: "https://paro.minex360.com",
        sentryDSN: "https://feed6d2fafbd483f85ff7abb77ba02d8@sentry.smartsapp.com/25",
    },
    'prod-candidate': {
        attendance: "https://attendance.seinti.net",
        unifiedApi: "https://unified-api.seinti.net",
        authApi: "https://auth.seinti.net",
        canteenApi: "https://canteen-v2.seinti.net",
        notificationApi: "https://notifications.seinti.net",
        elearningApi: "https://elearning.seinti.net",
        paymentsApi: "https://smartpay.seinti.net",
        paroApi: "https://paro.seinti.net",
        sentryDSN: "https://feed6d2fafbd483f85ff7abb77ba02d8@sentry.smartsapp.com/25",
    }
};


export default envBaseURLs[process.env.REACT_APP_ENV_NAME as keyof typeof envBaseURLs];